import {
  Alert,
  CreateButton,
  CRUDLayout,
  Pagination,
  ReadButton,
  Table,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr,
  UpdateButton,
} from 'components'
import {
  Button,
  ButtonFilter,
  DataStatus,
  InputSearch
} from 'components2'
import { Formik } from 'formik'
import { debounce } from 'lodash'
import { useEffect, useState } from 'react'
import { ButtonGroup } from 'react-bootstrap'
import { useQuery } from 'react-query'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { DateConvert } from 'utilities'
import { tableNumber } from 'utilities2'
import MaintenanceRequestApi from './__MaintenanceRequestApi__'
import {
  ModalFilter
} from './__MaintenanceRequestComps__'

export const MaintenanceRequest = ({ setNavbarTitle }) => {
  const history = useHistory();
  const { state } = useLocation();

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    text: '',
    variant: 'primary',
  });

  const [filter, setFilter] = useState({
    q: '',
    page: 1,
    per_page: 10,
    tgl_maintenance_request_start: undefined,
    tgl_maintenance_request_end: undefined,
    status_checklist: undefined,
    get_item: undefined,
    active: false,
  });

  const [modalFilter, setModalFilter] = useState(false);

  const getAnalisaChecklist = useQuery(
    ['analisa_checklist', 'list', filter],
    () => MaintenanceRequestApi.getList(filter)
  );

  const searchHandler = (e) => {
    const searchKey = e.target.value ? e.target.value : undefined;

    setFilter({
      ...filter,
      q: searchKey,
    });
    setAlertConfig({
      show: searchKey ? true : false,
      variant: 'primary',
      text: 'Hasil dari pencarian: ' + searchKey,
    });
  };

  const onFilterButtonClickkHandler = () => setModalFilter(!modalFilter);

  const onPaginationChange = ({ selected }) =>
    setFilter({ ...filter, page: selected + 1 });

  const onPaginationDataLengthChange = (e) =>
    setFilter({ ...filter, page: 1, per_page: e.target.value });

  const checkAlert = () => {
    if (state) {
      if (state.alert) {
        setAlertConfig({
          show: state?.alert?.show,
          text: state?.alert?.text,
          variant: state?.alert?.variant,
        });
      }
    }
  };

  // FORM VALUES FILTER
  const formInitialValuesFilter = {
    tgl_maintenance_request_start: filter?.tgl_maintenance_request_start,
    tgl_maintenance_request_end: filter?.tgl_maintenance_request_end,
    status_checklist: filter?.status_checklist,
    get_item: filter?.get_item,
  };

  const formSubmitHandlerFilter = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    setFilter({
      ...filter,
      ...values,
      active: checkActive,
      page: 1,
    });
    onFilterButtonClickkHandler();
  };

  useEffect(() => {
    setNavbarTitle('Maintenance Request');
    checkAlert();
  }, []);

  const ItemCollapse = ({ data }) => {
    const [isReadMoreClick, setisReadMoreClick] = useState(false);
    return (
      <>
        <ul className="pl-3 mb-1" style={{ fontSize: '12px' }}>
          {data.map((brg, index) => {
            if (isReadMoreClick) {
              return (
                <li key={index} index={index}>
                  {brg.nama_item_aset}
                </li>
              );
            } else {
              return (
                index < 2 && (
                  <li key={index} index={index}>
                    {brg.nama_item_aset}
                  </li>
                )
              );
            }
          })}
        </ul>
        {data.length > 2 && (
          <div
            className="text-primary"
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => setisReadMoreClick((prev) => !prev)}
          >
            {isReadMoreClick ? 'Sembunyikan' : 'Selengkapnya...'}
          </div>
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              onChange={debounce(searchHandler, 700)}
              className="mr-2"
            />
            <ButtonFilter
              size="sm"
              className="text-nowrap"
              onClick={onFilterButtonClickkHandler}
              active={filter?.active}
            />
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection>
          <CreateButton
            size="md"
            icon
            onClick={() => history.push('maintenance-request/tambah')}
          />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {getAnalisaChecklist.isLoading || getAnalisaChecklist.isError ? (
        <DataStatus
          loading={getAnalisaChecklist.isLoading}
          text={
            getAnalisaChecklist.isLoading ? 'Memuat . . .' : 'Data gagal dimuat'
          }
        />
      ) : (
        <>
          <Alert
            show={alertConfig?.show}
            text={alertConfig?.text}
            variant={alertConfig?.variant}
            showCloseButton
            onClose={() =>
              setAlertConfig({
                ...alertConfig,
                show: false,
              })
            }
          />
          <div className="mt-2">
            <small className="font-weight-bold">
              List Data Maintenance Request
            </small>
          </div>
          <Table>
            <THead>
              <Tr>
                <ThFixed>No.</ThFixed>
                <ThFixed>Aksi</ThFixed>
                <ThFixed>Informasi Maintenance Request</ThFixed>
                <Th className="p-1">Item Aset</Th>
                <ThFixed>Status Checklist</ThFixed>
              </Tr>
            </THead>
            <TBody>
              {getAnalisaChecklist?.data?.data?.length > 0 ? (
                getAnalisaChecklist?.data?.data?.map((e, index) => (
                  <Tr key={index}>
                    <TdFixed>
                      {tableNumber({
                        pageCurrent: filter.page,
                        dataLength: filter.per_page,
                        index,
                      })}
                    </TdFixed>
                    <TdFixed>
                      <ButtonGroup size='sm'>
                        <ReadButton
                          icon
                          noText
                          onClick={() =>
                            history.push(
                              '/transaksi/maintenance-request/detail/' +
                                e?.id_maintenance_request_master
                            )
                          }
                        />
                        {e?.status_checklist === 'pending' && (
                          <UpdateButton
                            icon
                            noText
                            variant="success"
                            onClick={() =>
                              history.push(
                                '/transaksi/maintenance-request/ubah/' +
                                  e?.id_maintenance_request_master
                              )
                            }
                          />
                        )}
                      </ButtonGroup>
                    </TdFixed>
                    <Td>
                      <div>
                        {
                          DateConvert(
                            new Date(e?.tgl_maintenance_request_master)
                          ).custom
                        }
                      </div>
                      <div>{e.no_maintenance_request_master ?? '-'}</div>
                    </Td>
                    <Td>
                      <ItemCollapse data={e.list_item_aset ?? []} />
                    </Td>
                    <Td>
                      {e?.status_checklist === 'pending' ? (
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          text="Pending"
                        />
                      ) : e?.status_checklist === 'reject' ? (
                        <Button
                          size="sm"
                          variant="outline-danger"
                          text="Reject"
                        />
                      ) : (
                        <Button
                          size="sm"
                          variant="outline-success"
                          text="Approved"
                        />
                      )}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={11}>
                    <DataStatus text="Tidak ada data" />
                  </Td>
                </Tr>
              )}
            </TBody>
          </Table>
          <Pagination
            dataLength={filter?.per_page}
            dataNumber={filter?.page * filter?.per_page - filter?.per_page + 1}
            dataPage={
              filter?.dataCount < filter?.per_page
                ? filter?.dataCount
                : filter?.page * filter?.per_page
            }
            dataCount={getAnalisaChecklist?.data?.data_count}
            currentPage={filter?.page}
            totalPage={getAnalisaChecklist?.data?.total_page}
            onPaginationChange={onPaginationChange}
            onDataLengthChange={onPaginationDataLengthChange}
          />
        </>
      )}

      {modalFilter && (
        <Formik
          enableReinitialize
          initialValues={formInitialValuesFilter}
          onSubmit={formSubmitHandlerFilter}
        >
          <ModalFilter toggle={onFilterButtonClickkHandler} />
        </Formik>
      )}
    </CRUDLayout>
  );
};
